<script lang="ts" setup>
  import { defineComponent, onMounted, reactive } from "vue";

  import BreadCrumb from "../../components/Common/BreadCrumb.vue";

  //servicos
  import * as serviceUsuarios from "@/services/usuariosService";

  //componentes
  import Paginador from "@/components/Paginador/Index.vue";
  import ImgUsuario from "@/components/Imagens/ImgUsuario.vue";
  import MsgBox from "@/components/MsgBox/Index.vue";

  var controle = reactive({
    filtros: {
      statusId: null,
      tipoId: null,
      paginaAtual: 1,
      tamanhoPagina: 10
    } as unknown as serviceUsuarios.UsuarioFiltros,
    itens: [] as serviceUsuarios.Usuario[],

    tipos: [] as serviceUsuarios.UsuarioTipo[],
    listaStatus:[ 
      {valor: null, descricao:"- Todos -"},
      {valor: true, descricao:"Ativos"},       
      {valor: false, descricao:"Inativos"},
    ],
    itemExcluir: null as serviceUsuarios.Usuario | null,
    janExcluir: false,

    itemAlterarSenha: null as serviceUsuarios.Usuario | null,
    janAlterarSenha: false,
    formSenha: {
      senhaNova: '',
      confirmaNovaSenha: '',
    },

    status: "",
    erro: "",

    ordenacao: {
      coluna: '',
      asc: true
    },
  })

  onMounted(async ()=>{
    controle.tipos = await serviceUsuarios.obterTipos();
    pesquisar();
  })

  async function pesquisar() {

    serviceUsuarios.obter(controle.filtros)
    .then(r=> {
      controle.itens = r;
    })
    .catch(erro=> {
      controle.erro = erro;
    })
  }

  function defineTipo(tipoId: number | undefined) {
    var tipo = controle.tipos.find(t => t.tipoId === tipoId);
    if (tipo) {
      return tipo.descricao; 
    } else {
      return "Desconhecido";  
    }
  }

  function ordenarPor(coluna: string) {
    if (controle.ordenacao.coluna === coluna) {
      controle.ordenacao.asc = !controle.ordenacao.asc;
    } else {
      controle.ordenacao.coluna = coluna;
      controle.ordenacao.asc = true;
    }
    controle.itens.sort((a, b) => {
      let valA = (a as Record<string, any>)[coluna];
      let valB = (b as Record<string, any>)[coluna];
      if (typeof valA === 'string') valA = valA.toLowerCase();
      if (typeof valB === 'string') valB = valB.toLowerCase();
      if (valA < valB) return controle.ordenacao.asc ? -1 : 1;
      if (valA > valB) return controle.ordenacao.asc ? 1 : -1;
      return 0;
    });
  }

  function abrirAlterarSenha(item: serviceUsuarios.Usuario) {
    controle.itemAlterarSenha = item;
    controle.formSenha.senhaNova = '';
    controle.formSenha.confirmaNovaSenha = '';
    controle.janAlterarSenha = true;
  }

  function confirmarAlterarSenha() {
    if (!controle.itemAlterarSenha) return;
    controle.status = "Alterando senha...";
    controle.erro = "";
    serviceUsuarios.alterarSenha(
      controle.itemAlterarSenha.usuarioId,
      controle.formSenha.senhaNova,
      controle.formSenha.confirmaNovaSenha
    )
    .then(() => {
      controle.status = "Senha alterada com sucesso!";
      setTimeout(() => {
        controle.janAlterarSenha = false;
        controle.status = "";
      }, 3000);
    })
    .catch(erro => {
      controle.erro = erro;
      controle.status = "";
    });
  }

  function pergExcluir(item: serviceUsuarios.Usuario) {
    controle.janExcluir = true;
    controle.itemExcluir = item;
  }

  function excluir() {
    if (controle.itemExcluir) {
      serviceUsuarios.excluir(controle.itemExcluir.usuarioId!)
        .then(() => {
          controle.janExcluir = false;
          pesquisar();
        })
        .catch(erro => {
          controle.erro = erro;
          controle.janExcluir = false;
        });
    }
  }
</script>

<template>
  <BreadCrumb PageTitle="Usuários" />

  <div class="card">
    <div class="card-body">
      <div class="row">
        <div class="col-6 col-md-3">
          <label><i class="flaticon-search"></i> Pesquisar</label>
          <input type="text" class="form-control form-control-sm" placeholder="Nome, email..." v-model="controle.filtros.nome" @keyup="pesquisar" />
        </div>

        <div class="col-6 col-md-3">
          <label>Tipo</label>
          <select class="form-select form-select-sm" v-model="controle.filtros.tipoId" @change="pesquisar">
            <option :value="null">- Todos -</option>
            <option v-for="(item) in controle.tipos" :value="item.tipoId" :key="item.tipoId">{{ item.descricao }}</option>
          </select>
        </div>

        <div class="col-6 col-md-3">
          <label>Status</label>
           <select class="form-select form-select-sm" v-model="controle.filtros.ativo" @change="pesquisar">
            <option v-for="(item,idx) in controle.listaStatus" :value="item.valor" :key="idx">{{ item.descricao }}</option>
          </select>
        </div>

        <div class="col-6 col-md-3">
          <RouterLink class="btn btn-primary btn-sm mt-4 float-end" :to="'/usuarios/cadastro'"><i class="flaticon-plus"></i> Adicionar</RouterLink>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-md-12 table-responsive">
          <table class="table  align-middle mb-0 table-hover">
            <thead>
              <tr>
                <th @click="ordenarPor('usuarioId')" class="th-sortable">Id</th>
                <th @click="ordenarPor('nomeCompleto')" class="th-sortable">Usuário</th>
                <th @click="ordenarPor('tipoId')" class="th-sortable">Tipo</th>
                <th @click="ordenarPor('email')" class="th-sortable">Email</th>
                <th @click="ordenarPor('ativo')" class="th-sortable">Status</th>
                <th>Opções</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item,idx) in controle.itens" :key="idx" class="align-middle">
                <td>{{item.usuarioId}}</td>
                <td class="nowrap-celular">
                  <ImgUsuario :usuarioId="item.usuarioId" :alt="item.nomeCompleto" />
                  {{item.nomeCompleto}}
                </td>
                <td>{{defineTipo(item.tipoId)}}</td>
                <td class="text-lowercase">{{item.email}}</td>
                <td>
                  <span class="badge rounded-pill" :class="item.ativo ? 'badge-soft-success' : 'badge-soft-danger'">
                    {{ item.ativo ? 'Ativo' : 'Inativo' }}
                  </span>
                </td>
                <td class="text-center text-nowrap">
                  <span>
                    <RouterLink :to="'/usuarios/cadastro/' + item.usuarioId">
                        <i class="flaticon-pen fs-5"></i>
                    </RouterLink>

                    <a class="ms-2" href="javascript:void(0);" @click="abrirAlterarSenha(item)" title="Alterar Senha">
                      <i class="flaticon-lock fs-5 text-warning"></i>
                    </a>

                     <a class="ms-2" href="javascript:void(0);" @click="pergExcluir(item)">
                        <i  class="flaticon-delete fs-5 text-danger" ></i>
                      </a>
                  </span>
                  
                </td>
              </tr>
            </tbody>
          </table>  
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-md-4">
           {{ controle.itens.length }} Registros
        </div>
        <div class="col-md-6">
          <Paginador class="float-end"
            :paginaAtual="controle.filtros.paginaAtual"
            :tamanhoPagina="controle.filtros.tamanhoPagina"
            :totalItens="controle.itens.length"
            @on-change="(el) => { 
              controle.filtros.paginaAtual = el.paginaAtual; 
              controle.filtros.tamanhoPagina = el.tamanhoPagina;
              pesquisar() }" />
        </div>
        <div class="col-md-2">
          <RouterLink class="btn btn-secondary btn-sm float-end" :to="'/'">Fechar</RouterLink>
        </div>
      </div>
    </div>
  </div>

  <MsgBox :id="'janExcluir'" :titulo="'Atenção'" :exibir="controle.janExcluir" @onFechou="controle.janExcluir = false"
        :botao-sim="true" :botao-nao="true" @onSim="excluir()" >
      <div class="row">
          <div class="col-md-12 fw-bold fs-6">
              Deseja excluir este registro?
          </div>
      </div>
  </MsgBox>

  <MsgBox :id="'janAlterarSenha'" :titulo="'Alterar Senha'" :tamanho="'modal-sm'" :exibir="controle.janAlterarSenha"
        @onFechou="controle.janAlterarSenha = false" :botao-gravar="true" :botao-fechar="true"
        @onGravar="confirmarAlterarSenha()">
      <div class="row">
          <div class="col-md-12 fw-bold fs-6 mb-3">
              {{ controle.itemAlterarSenha?.nomeCompleto }}
          </div>
          <div class="col-md-12 mb-2">
              <label>Nova Senha</label>
              <input type="password" class="form-control form-control-sm" v-model="controle.formSenha.senhaNova" />
          </div>
          <div class="col-md-12">
              <label>Confirmar Nova Senha</label>
              <input type="password" class="form-control form-control-sm" v-model="controle.formSenha.confirmaNovaSenha" />
          </div>

          <div class="col-md-12 mt-2">
              <div class="alert alert-danger" v-if="controle.erro">{{ controle.erro }}</div>
               <div class="alert alert-success" v-if="controle.status">{{ controle.status }}</div>
          </div>
      </div>
  </MsgBox>
</template>

<style lang="css" scoped>

.form-control {
  background: #F5F4FA;
}

.th-sortable {
  cursor: pointer;
  user-select: none;
}

a {
  text-decoration: none;
}

/* Evita quebra de linha nas colunas de nome/telefone apenas no celular */
@media (max-width: 767.98px) {
  .nowrap-celular {
    white-space: nowrap;
  }
}
</style>